/**
 * Cursor guía del workshop: una flecha que viaja hasta el elemento que la
 * narración está mostrando y "hace clic" con una onda. Es puramente visual
 * (pointer-events: none); el clic real lo despacha el motor (dom.ts).
 */
import { useRef } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import type { CursorState } from './engine';

export function FakeCursor({ cursor }: { cursor: CursorState }) {
  const reduce = useReducedMotion();
  const last = useRef({ x: cursor.x, y: cursor.y });
  const dist = Math.hypot(cursor.x - last.current.x, cursor.y - last.current.y);
  last.current = { x: cursor.x, y: cursor.y };
  // misma fórmula que el motor (engine.moveTo): el cursor llega cuando el clic sale
  const duration = reduce ? 0 : Math.min(0.9, 0.3 + dist * 0.00045);

  return (
    <motion.div
      aria-hidden
      className="pointer-events-none fixed left-0 top-0 z-206"
      initial={false}
      animate={{ x: cursor.x, y: cursor.y, opacity: cursor.visible ? 1 : 0, scale: cursor.visible ? 1 : 0.6 }}
      transition={{ x: { duration, ease: [0.22, 1, 0.36, 1] }, y: { duration, ease: [0.22, 1, 0.36, 1] }, opacity: { duration: 0.25 }, scale: { duration: 0.25 } }}
    >
      <AnimatePresence>
        {cursor.clicks > 0 && (
          <motion.span
            key={cursor.clicks}
            className="absolute -left-5 -top-5 h-10 w-10 rounded-full border-2 border-brand-green bg-brand-green/25"
            initial={{ scale: 0.25, opacity: 0.9 }}
            animate={{ scale: 1.4, opacity: 0 }}
            exit={{ opacity: 0 }}
            transition={{ duration: reduce ? 0 : 0.55, ease: 'easeOut' }}
          />
        )}
      </AnimatePresence>
      <svg width="26" height="30" viewBox="0 0 26 30" className="ml-[-3px] mt-[-2px] drop-shadow-[0_2px_4px_rgba(0,0,0,0.45)]">
        <path d="M3 2 L3 24 L8.4 18.6 L12.2 27.4 L16.4 25.6 L12.6 17 L20 17 Z" fill="#FFFFFF" stroke="#0B1513" strokeWidth="1.8" strokeLinejoin="round" />
      </svg>
    </motion.div>
  );
}
